export interface SupportTicketModuleOption {
  label: string;
  value: string;
}

export interface AdminSupportTicketModule extends SupportTicketModuleOption {
  permissionModule: string;
}

export const CASHIER_SUPPORT_TICKET_MODULES: SupportTicketModuleOption[] = [
  { label: 'Caisse', value: 'cashier_sales' },
  { label: 'Inventaires', value: 'inventories' },
  { label: 'Fin de journée', value: 'end_of_day' },
  { label: 'Dépenses', value: 'expenses' },
  { label: 'Notifications', value: 'notifications' },
  { label: 'Profil / paramètres', value: 'profile_settings' },
  { label: 'Autre', value: 'other' },
];

export const ADMIN_SUPPORT_TICKET_MODULES: AdminSupportTicketModule[] = [
  { label: 'Tableau de bord', value: 'dashboard', permissionModule: 'dashboard' },
  { label: 'Sites', value: 'shops', permissionModule: 'shops' },
  { label: 'Produits', value: 'products', permissionModule: 'products' },
  { label: 'Promotions', value: 'promotions', permissionModule: 'promotions' },
  { label: 'Fournisseurs', value: 'suppliers', permissionModule: 'suppliers' },
  { label: 'Achats', value: 'purchases', permissionModule: 'purchases' },
  { label: 'Dépenses', value: 'expenses', permissionModule: 'expenses' },
  { label: 'Retours fournisseur', value: 'supplier_returns', permissionModule: 'supplier_returns' },
  { label: 'Mouvements de stock', value: 'stock_movements', permissionModule: 'stock_movements' },
  { label: 'Portefeuilles électroniques', value: 'wallet', permissionModule: 'wallet' },
  { label: 'Transferts de stock', value: 'stock_transfers', permissionModule: 'stock_transfers' },
  { label: 'Inventaires', value: 'inventories', permissionModule: 'inventories' },
  { label: 'Clients', value: 'clients', permissionModule: 'clients' },
  { label: 'Ventes', value: 'sales', permissionModule: 'sales' },
  { label: 'Caisses', value: 'cash_registers', permissionModule: 'cash_registers' },
  { label: 'Billetage', value: 'cash_counts', permissionModule: 'cash_counts' },
  { label: 'Livraisons', value: 'deliveries', permissionModule: 'deliveries' },
  { label: 'E-commerce', value: 'ecommerce', permissionModule: 'ecommerce' },
  { label: 'Rapports', value: 'reports', permissionModule: 'reports' },
  { label: 'Utilisateurs', value: 'users', permissionModule: 'users' },
  { label: 'Paramètres', value: 'settings', permissionModule: 'settings' },
  { label: 'Notifications', value: 'notifications', permissionModule: 'notifications' },
];

export const ALWAYS_AVAILABLE_SUPPORT_TICKET_MODULES: SupportTicketModuleOption[] = [
  { label: 'Profil / paramètres', value: 'profile_settings' },
  { label: 'Autre', value: 'other' },
];
